export default {
  title: 'Bericht des Verkaufsteams',
  fields: {
    name: 'Name',
    area: 'Bereich',
    signed: 'Unterzeichnet',
    live: 'Live',
  },
  buttons: {
    download_report: 'Bericht herunterladen',
  },
  toasts: {
    failed_to_load_data: 'Die Daten konnten nicht geladen werden, bitte aktualisieren Sie die Seite',
  },
};
